"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardService = void 0;
var tslib_1 = require("tslib");
var _1 = require(".");
var DashboardService = /** @class */ (function () {
    function DashboardService() {
        this.__priority = 50;
    }
    DashboardService.prototype.getPoleStatusTotals = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = _1.Services.Department.rest;
                        return [4 /*yield*/, rest.action('collection.total.status.summary', '')];
                    case 1: return [2 /*return*/, ((_a.sent()).results)];
                }
            });
        });
    };
    DashboardService.prototype.getPoleStatusSummary = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = _1.Services.Department.rest;
                        return [4 /*yield*/, rest.action('collection.status.summary', '')];
                    case 1: return [2 /*return*/, ((_a.sent()).results)];
                }
            });
        });
    };
    DashboardService.prototype.getPoleLoadingSummary = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = _1.Services.Department.rest;
                        return [4 /*yield*/, rest.action('collection.loading.summary', '')];
                    case 1: return [2 /*return*/, ((_a.sent()).results)];
                }
            });
        });
    };
    return DashboardService;
}());
exports.DashboardService = DashboardService;
//# sourceMappingURL=dashboard.service.js.map